<template>
<div>

</div>
</template>

<script>
import store from "@/store/store";
import * as util from "@/vendor/util";
import * as qconst from "@/vendor/qconstants";
import * as xhr from "@/api/xhr";
import {ebus} from "@/vendor/ebus";

export default {
  name: "RestoreCartItems",
  created(){
    ebus.$on('restoreCartFromServer', (cartId) => {
      this.restoreCartFromServer(cartId);
    });

    // ebus.$on('pageVisible', () => {
    //   this.restoreCartItems();
    // });
  },

  beforeMount() {
    this.restoreCartItems();
  },

  methods:{
    restoreCartItems() {
      console.log('restoreCartItems...');
      let finished = false;
      if (store.state.cartId.length > 0) {
        console.log('NO restoreCartItems');
        return;
      }
      try {
        let storedItemsRaw = this.$ls.get('cartItems');
        if (storedItemsRaw && storedItemsRaw.items) {
          finished = true;

          //not older than 12 hours
          if ((Date.now() - storedItemsRaw.timestamp) < (12 * 60 * 60 * 1000)) {
            let storedItems = util.cloneMe(storedItemsRaw.items);
            // console.log('restoreCartItems length = ' + storedItems.items.length);
            // store.commit('deleteAllCartItems');
            store.commit('restoreCartItems', {items: storedItems});
          } else {
            console.log('restoreCartItems blocked because timestamp exceeded' + storedItemsRaw.timestamp);
          }
        } else {
          finished = true;
        }
      } catch (e) {
        console.log('Error in protected restoreCartItems: ' + e.message);
      } finally {
        if (!finished) {
          //retry
          setTimeout(() => {
            console.log('retry cartItems');
            this.restoreCartItems();
          }, 400);
        }
      }
    },

    restoreCartFromServer(cartId) {
      console.log('restoreCartFromServer....');
      let msg = {
        action: qconst.action$LoadCartItems,
        cartId: cartId
      };
      xhr.xhrSend(true, msg, (data) => {
        // store.commit('cartId', '');
        if (data && data.ok && data.cart) {

          console.log('restoreCartFromServer reply cart: ' + JSON.stringify(data.cart));

          //not older than 4 hours
          if ((Date.now() - data.cart.lastModified) < (4 * 60 * 60 * 1000)) {
            let sourceDevice = '';
            if (data.cart.context && data.cart.context.sourceDevice) {
              sourceDevice = data.cart.context.sourceDevice;
            }
            store.commit('deleteAllCartItems');
            store.commit('restoreCartItems', {items: data.cart.items});
            console.log('serverCart successfully restored with ' + data.cart.items.length + ' items');
            if (store.getters.cartItems.length > 0) {
              util.removeAllQueryParams();
              this.$router.push({name: 'Korb'});
              if (sourceDevice === 'orderTerminal') {
                setTimeout(() => {
                  this.$router.push({name: 'checkoutMobileInhouseWithPay'});
                }, 200);
                // }else{
                //     alert('sourceDevice '+sourceDevice);
              }
              setTimeout(() => {
                store.commit('cartId', '');
              }, 20 * 1000);
            }
          } else {
            console.log('restoreCartFromServer cart is older than 4 hours');
            store.commit('cartId', '');
            this.restoreCartItems();
          }
        } else {
          console.log('Error in restoreCartFromServer');
          ebus.$emit('toast', 'Items could not be loaded. Please reload the page to try again');
        }
      }, (err) => {
        // logError('Load orders');
        console.log('Error in restoreCartFromServer: ' + err.message);
      });
    },
  },
}
</script>

<style scoped>

</style>
